import apiClient from '../utils/apiClient';

export interface PBMOutputMapping {
  id: number;
  description: string;
}

export const getAllOutputMappings = async (): Promise<PBMOutputMapping[]> => {
  return await apiClient.get<PBMOutputMapping[]>('/api/pbmoutputmapping');
};
